import React, { useState, useEffect } from 'react'
import { FaSearch } from 'react-icons/fa'
import Photo from './Photo'
const clientID = '?client_id=Erqx-BFr-oHMkmczDWwwQZx_sUjItylDGRbvr4V-utY';
const mainUrl = `https://api.unsplash.com/photos/`
const searchUrl = `https://api.unsplash.com/search/photos/`

function App() 
{
  const [ loading, setLoading ] = useState(false);
  const [ page, setPage ] = useState(0);
  const [ query, setQuery ] = useState('');
  const [ photos, setPhotos ] = useState([]);

  const fetchImages = async ()=>
  {
    setLoading(true);
    const pageUrl = `&page=${page}`;
    const queryUrl = `&query=${query}`;
    let url;
    if(query)
    {
      url = `${searchUrl}${clientID}${pageUrl}${queryUrl}`;
    }
    else
    {
      url = `${mainUrl}${clientID}${pageUrl}`;
    }
    const response = await fetch(url);
    const data = await response.json();
    if(query && page === 1)
    {
      const {results} = data;
      setPhotos(results);
    }
    else if(query)
    {
      const {results} = data;
      setPhotos([...photos, ...results]);
    }
    else
    {
      setPhotos([...photos, ...data]);
    }
    setLoading(false);
  }

  useEffect(()=>
  {
    fetchImages();
    // eslint-disable-next-line
  }, [page])

  const event = ()=>
  {
    const { innerHeight, scrollY } = window;
    const { body } = document;
    let { scrollHeight } = body;
    scrollHeight = scrollHeight - 2;
    const totalHeight = innerHeight + scrollY;
    if(!loading && totalHeight >= scrollHeight)
    {
      setPage((previousPage)=>
      {
        return previousPage + 1;
      });
    }
  }

  useEffect(()=>
  {
    window.addEventListener('scroll', event);
    return ()=> window.removeEventListener('scroll', event);
    // eslint-disable-next-line
  }, [])

  const handleSubmit = (e)=>
  {
    e.preventDefault();
    if(!query)
    {
      return;
    }
    if(page === 1)
    {
      fetchImages();
    }
    setPage(1);
  }

  return (
  <main>
    <h1>Stock Photos Project</h1>
    <section className = "search">
      <form className = "search-form">
        <input type='text' placeholder='search' value={query} onChange={(e) => setQuery(e.target.value)} className='form-input'/>
        <button type = 'submit' className = 'submit-btn' onClick = {handleSubmit}><FaSearch/></button>
      </form>
    </section>
    <section className="photos">
      <div className = "photos-center">
        {
          photos.map((photo, index)=>
          {
            return <Photo key = {index} {...photo} />;
          })
        }
      </div>
      {loading && <h2 className='loading'>Loading...</h2>}
    </section>
  </main>);
}

export default App;
